var _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9998,
    cy: 13.0002,
    r: 12,
    transform: "rotate(-178.971 12.9998 13.0002)",
    fill: "grey"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.9512,
    y: 15.7021,
    width: 3.99999,
    height: 10.6666,
    rx: 2,
    transform: "rotate(-178.971 14.9512 15.7021)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.8555,
    y: 21.0347,
    width: 3.99999,
    height: 3.99999,
    rx: 2,
    transform: "rotate(-178.971 14.8555 21.0347)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyIcon);
export default __webpack_public_path__ + "static/media/grey-icon.a8bb0c56734bf10fb7019dc7c5058661.svg";
export { ForwardRef as ReactComponent };